<template>
  <NewStudioModalsModalShell class="load-modal" title="Load Design" size="compact" data-figma-node="2909:175967" @close="$emit('close')">
    <form @submit.prevent="loadDesign">
      <label for="new-load-id">Design ID</label>
      <input id="new-load-id" v-model.trim="designId" type="text" placeholder="1234" autocomplete="off">
      <p v-if="error" role="alert">{{ error }}</p>
      <button type="submit" :disabled="loading || !designId">{{ loading ? 'Loading…' : 'Load Design' }}</button>
    </form>
  </NewStudioModalsModalShell>
</template>

<script setup lang="ts">
defineEmits<{ close: [] }>()
const projectStore = useProjectStore()
const gridStore = useGridStore()
const modalStore = useModalStore()
const loadingStore = useLoadingStore()
const designId = ref('')
const error = ref('')
const loading = ref(false)
const loadDesign = async () => {
  if (!designId.value) return
  error.value = ''
  loading.value = true
  loadingStore.setLoading(true)
  try {
    const design = await projectStore.load(designId.value)
    if (!design) throw new Error('Design not found')
    await gridStore.loadDesign(design)
    modalStore.handleSuccess(ModalType.Load)
  } catch (reason) {
    error.value = reason instanceof Error && reason.message === 'Design not found' ? 'Design not found' : 'Error loading design'
  } finally {
    loading.value = false
    loadingStore.setLoading(false)
  }
}
</script>

<style scoped>
form { display: grid; gap: 17.95px; margin-top: 17.95px; } label { display: grid; gap: 8px; font-size: 17.052px; font-weight: 600; }
input { box-sizing: border-box; height: 50px; padding: 0 18px; border: 2px solid #d9d8d3; font: inherit; font-size: 17.95px; font-weight: 600; }
p[role='alert'] { margin: 0; color: #a32121; font-size: 13px; }
button { min-height: 52px; border: 0; background: #2e3a46; color: #fff; font: inherit; font-size: 16.155px; font-weight: 700; cursor: pointer; }
button:disabled { cursor: not-allowed; }
:global(.load-modal > h2) { margin-top: 17.95px; text-align: left; font-size: 34.105px; letter-spacing: -.341px; }
:global(.load-modal) { box-sizing: border-box; height: 305px; }
</style>
